import { Injectable } from '@angular/core';
import * as Fingerprint2 from 'fingerprintjs2';

@Injectable()
export class DetectBrowser {

  public isSafari() {
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    }

    public isIE() {
        let isMSStream = false;
        if (window.hasOwnProperty('MSStream')) {
            if (window['MSStream']) {
                isMSStream = true;
            } else {
                isMSStream = false;
            }
        }
        return isMSStream;
    }

    public isIEAndNotEdge() {
      let isMSStream = false;
      if (window.hasOwnProperty('MSStream')) {
          if (window['MSStream']) {
              isMSStream = true;
          } else {
              isMSStream = false;
          }
      }
      return isMSStream && (navigator.appName === 'Microsoft Internet Explorer' || navigator.appName === 'Netscape')
       && navigator.userAgent.indexOf('Edge') < 0;
    }

    public isChrome() {
      const isChrome = navigator.userAgent.indexOf('Chrome') > -1 ? true : false;
      if (!this.isIE() && isChrome) {
        return true;
      } else {
        return false;
      }

    }

   public getDeviceLoggedIn() {
      const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
           // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
           return MobileDevices.WindowsPhone;
        }
        if (/android/i.test(userAgent)) {
            return MobileDevices.Andriod;
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
            return MobileDevices.IOS;
        }
        return MobileDevices.Other;
    }

    public getDeviceFingerPrint(): string {
      return localStorage.getItem('browserFingerPrint');
    }
}


export enum MobileDevices {
  WindowsPhone = 1,
  Andriod = 2,
  IOS = 3,
  Other = 4
}
